module.exports = __webpack_public_path__ + "static/media/client-4.5c2c221a.jpg";